
import {Injectable} from '@angular/core';
import {ConfigService} from './service/config.service';

@Injectable()
export class ApiServiceService {
    public static RESPONSE = 'RESPONSE';

    constructor(private configService: ConfigService) {
    }

    public static isReferralSchemeEnabled() {
        return true;
    }

    public static isHybridInvestSchemeEnabled() {
        return true;
    }

    public baseURL(): string {
        return this.configService.baseUrl();
    }

    public getLoanExpiryDate(): number {
        return 31;
    }
}
